// =============================== Images ==========
import abuDhabi from "./images/abu-dhabi.jpg"
import armenia from "./images/armenia.jpg"
import baghdad from "./images/baghdad.jpg"
import bahrain from "./images/bahrain.jpg"
import beirut from "./images/beirut.jpg"
import budapest from "./images/budapest.jpg"
import cairo from "./images/cairo.jpg"
import cyprus from "./images/cyprus.jpg"
import dubai from "./images/dubai.jpg"
import erbil from "./images/erbil.jpg"
import greece from "./images/greece.jpg"
import iran from "./images/iran.jpg"
import kualaLampur from "./images/kuala-lampur.jpg"
import maldives from "./images/maldives.jpg"
import malka from "./images/malka.jpg"
import oman from "./images/oman.jpg"
import riydh from "./images/riyadh.jpg"
import russia from "./images/russia.jpg"
import sharija from "./images/sharija.jpg"
import yerevan from "./images/yerevan.jpg"
export let cities = [
    {
        img:abuDhabi,
        text:"ابو ظبي",
        en:"Abu Dhabi, UAE"
    },
    {
        img:armenia,
        text:"ارمينيا",
        en:"Armenia, Asia"
    },
    {
        img:baghdad,
        text:"بغداد",
        en:"Baghdad, Iraq"
    },
    {
        img:bahrain,
        text:"البحرين",
        en:"Bahrain, Middle East"
    },
    {
        img:beirut,
        text:"بيروت",
        en:"Beirut, Lebanon"
    },
    {
        img:budapest,
        text:"بودابست",
        en:"Budapest, Hungary"
    },
    {
        img:cairo,
        text:"القاهرة",
        en:"Cairo, Egypt"
    },
    {
        img:cyprus,
        text:"قبرص",
        en:"Cyprus, Middle East"
    },
    {
        img:dubai,
        text:"دبي",
        en:"Dubai, UAE"
    },
    {
        img:erbil,
        text:"اربيل",
        en:"Erbil, Iraqi Kurdistan"
    },
    {
        img:greece,
        text:"اليونان",
        en:"Greece, Balkans"
    },
    {
        img:iran,
        text:"ايران",
        en:"Iran, Middle East"
    },
    {
        img:kualaLampur,
        text:"كوالا لامبور",
        en:"Kuala Lumpur, Malaysia"
    },
    {
        img:maldives,
        text:"المالديف",
        en:"Maldives, South Asia"
    },
    {
        img:malka,
        text:"مالقة",
        en:"Málaga, Spain",
    },
    {
        img:oman,
        text:"عمان",
        en:"Oman, Middle East"
    },
    {
        img:riydh,
        text:"الرياض",
        en:"Riyadh, Saudi Arabia"
    },
    {
        img:russia,
        text:"روسيا",
        en:"Russia"
    },
    {
        img:sharija,
        text:"الشارقة",
        en:"Sharjah, UAE"
    },
    {
        img:yerevan,
        text:"يريفان",
        en:"Yerevan, Armenia"
    }
]